import { Component, ViewContainerRef } from '@angular/core';
import { WidgetService } from '../../services/widget/widget.service';
import { CategoryService } from '../../services/category/category.service';
import { BrandService } from '../../services/brand/brand.service';
import { WidgetTemplate } from '../../models/widget/widget-template.model';
import { WidgetContent } from '../../models/widget/widget-content.model';
import { PageWidget } from '../../models/widget/page-widget.model';
import { DynamicPage } from '../../models/widget/dynamic-page.model';
import { Brand } from '../../models/brand/brand-model';
import { DisplayCategory } from '../../models/category/DisplayCategory.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-page-widget-list',
    templateUrl: './page-widget-list.component.html',
    styleUrls: ['./page-widget-list.component.css']
})
/** page-widget-list component*/
export class PageWidgetListComponent {
  public widgetTemplateList: WidgetTemplate[];
  public pageWidget = new PageWidget();
  public widgetContentList: WidgetContent[] = [];
  public widgetContent = new WidgetContent();
  public dynamicPageList: DynamicPage[];
  public pageWidgetList: PageWidget[];
  multipleWidgetItems: MultipleWidgetItems[] = [];
  public categoryList: DisplayCategory[] = [];
  public subCategoryList: DisplayCategory[] = [];
  public selectedPopualarCategoryIds: any[] = [];
  public Brands: Brand[];
  brandTab = new BrandTabsList();
  customDPage: string;
  widgetTemplateID: number;
  selectedBrandImageLeft: string[];
  selectedBrandImageRight: string[];
  selectedCategoryImage2: string[];
  selectedCategoryImage: string[];
  selectedBannerImage: string[];
  selectedILoveAppBannerImage: string[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
    /** page-widget-list ctor */
  constructor(private readonly widgetService: WidgetService,
    private readonly categoryService: CategoryService,
    private readonly brandsService: BrandService,
    private readonly toastr: ToastsManager,
    vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService, private readonly router: Router) {
    this.checkPermission();
    this.toastr.setRootViewContainerRef(vcr);
    this.GetDynamicPages();
    this.GetAllBrands();
    this.GetAllDisplayCategoryList();
    this.GetWidgetTemplates();
    this.customDPage = "1";
    this.widgetTemplateID = 0;
    setTimeout(() => {
      this.LaodSavedWidgets();
    }, 3000);
   
  }
  checkPermission() {
    this.rolePermissionService.GetRolePermissions("pageWidget").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {



          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  GetDynamicPages() {
    this.widgetService.GetDynamicPages().subscribe(
      data => {
        this.dynamicPageList = data;
      }
    )
  }
  GetAllBrands() {
    this.brandsService.getBrand().subscribe(
      data => {
        this.Brands = data;
      });
  }
  GetAllDisplayCategoryList() {
    this.categoryService.GetAllDisplayCategoryList().subscribe(
      data => {
        this.categoryList = data;
        this.subCategoryList = this.categoryList.filter(s => s.isParent == false);
      }
    )
  }
  GetWidgetTemplates() {
    this.widgetService.GetWidgetTemplates().subscribe(
      data => {
        this.widgetTemplateList = data;
      }
    )
  }
  enumSelector(enumName) {
    return Object.keys(enumName)
      .map(key => ({ value: key, title: enumName[key] }));
  }
  deleteWidget(id) {
    var ans = confirm("Are you sure to delete this Widget? ");
    if (ans) {
      this.widgetService.DeletePageWidget(id);
      this.toastr.success('Widget deleted successfully.', 'Success');
      setTimeout(() => {
        this.LaodSavedWidgets();
      }, 2000);
    }
  }
  WidgetContentInitialization() {
    this.selectedCategoryImage = [];
    this.selectedBrandImageLeft = [];
    this.selectedBrandImageRight = [];
    this.pageWidget = new PageWidget();
    this.widgetContentList = [];
    this.selectedPopualarCategoryIds = [];
    this.selectedBannerImage = [];
    this.selectedILoveAppBannerImage = [];

  }
  LaodSavedWidgets() {
    this.WidgetContentInitialization();
    this.widgetService.GetSortedPageWidgetsByPageID(parseInt(this.customDPage), this.widgetTemplateID).subscribe(
      data => {
        this.pageWidgetList = data;
        for (var p = 0; p < this.pageWidgetList.length; p++) {
          //Intialization of Multiple widgets
          this.multipleWidgetItems[p] = new MultipleWidgetItems();
          // For Category List
          this.multipleWidgetItems[p].categoryBrandsList = [];
          this.multipleWidgetItems[p].thumbnailCategoryList = [];
          this.multipleWidgetItems[p].menuParentCategoryList = [];
          this.multipleWidgetItems[p].menuCategoryList = [];
          this.multipleWidgetItems[p].menuSubcategoryList = [];
          // For Popular Category Widget
          this.multipleWidgetItems[p].popularCategoryList = [];
          // For Brands
          this.multipleWidgetItems[p].brandTabsList = [];

          this.pageWidget.widgetTemplateID = this.pageWidgetList[p].widgetTemplateID;
          this.pageWidget.sortOrder = this.pageWidgetList[p].sortOrder;
          this.pageWidget.pageWidgetID = this.pageWidgetList[p].pageWidgetID;
          // retaining PageWID To check product widget
          //end for product widget
          this.pageWidget.id = this.pageWidgetList[p].id;
          this.widgetContentList = this.pageWidgetList[p].widgetContentList;
          var widgetTemplate = this.widgetTemplateList.find(s => s.widgetTemplateID == this.pageWidgetList[p].widgetTemplateID)
          if (widgetTemplate != null) {
            if (widgetTemplate.widgetType == WidgetTypes.Brands.toString()) {
              for (var i = 0; i < this.widgetContentList.length; i++) {
                //check if template is Brand Widget
                if (this.widgetContentList[i].type == WidgetContentTypes.HeroImage.toString()) {
                  // Data Structure BrandLeft: Url, Image" 
                  let arrData = this.PipeSignSpliter(this.widgetContentList[i].data);
                  let arrUrlAndImage = this.CommaSpliter(arrData[1]);
                  if (arrData[0].toString() == WidgetImageContents.BrandLeft.toString()) {
                    this.selectedBrandImageLeft[p] = "Images/WidgetContentImages/" + arrUrlAndImage[1];

                  } else if (arrData[0].toString() == WidgetImageContents.BrandRight.toString()) {
                    this.selectedBrandImageRight[p] = "Images/WidgetContentImages/" + arrUrlAndImage[1];
                  }

                } else if (this.widgetContentList[i].type == WidgetContentTypes.BrandTab.toString()) {
                  let arrBrandTabs = this.PipeSignSpliter(this.widgetContentList[i].data);
                  for (var j = 0; j < arrBrandTabs.length; j++) {
                    let arrTabAndIds = this.ColonSpliter(arrBrandTabs[j]);
                    this.brandTab = new BrandTabsList();
                    this.brandTab.tabTitle = arrTabAndIds[0];
                    let existingBrandIds = this.CommaSpliter(arrTabAndIds[1]);
                    for (var k = 0; k < existingBrandIds.length; k++) {
                      var selectedbrand = this.Brands.find(s => s.brandID == parseInt(existingBrandIds[k]));
                      this.brandTab.BrandsList.push(selectedbrand);
                    }
                    this.multipleWidgetItems[p].brandTabsList.push(this.brandTab);
                  }

                }
              }

            } else if (widgetTemplate.widgetType == WidgetTypes.Category1.toString() || widgetTemplate.widgetType == WidgetTypes.Category2.toString()) {
              // Load at page change
              // check to show all pages
              for (var cate1Index = 0; cate1Index < this.widgetContentList.length; cate1Index++) {
                if (this.widgetContentList[cate1Index].type == WidgetContentTypes.HeroImage.toString()) {
                  let arrUrlAndImage = this.CommaSpliter(this.widgetContentList[cate1Index].data);
                  this.selectedCategoryImage[p] = "Images/WidgetContentImages/" + arrUrlAndImage[1];

                } else if (this.widgetContentList[cate1Index].type == WidgetContentTypes.CategoryBannerBrands.toString()) {
                  let arrBrandIds = this.CommaSpliter(this.widgetContentList[cate1Index].data);
                  for (var i = 0; i < arrBrandIds.length; i++) {
                    var selectedbrand = this.Brands.find(s => s.brandID == parseInt(arrBrandIds[i]));
                    this.multipleWidgetItems[p].categoryBrandsList.push(selectedbrand);

                  }

                } else if (this.widgetContentList[cate1Index].type == WidgetContentTypes.ThumbnailCategoryList.toString()) {
                  let arrThumbnailCatIds = this.CommaSpliter(this.widgetContentList[cate1Index].data);
                  for (var i = 0; i < arrThumbnailCatIds.length; i++) {
                    var selectedCategory = this.subCategoryList.find(s => s.categoryID == parseInt(arrThumbnailCatIds[i]));
                    if (selectedCategory != null) {
                      this.multipleWidgetItems[p].thumbnailCategoryList.push(selectedCategory);
                    }
                  }

                } else if (this.widgetContentList[cate1Index].type == WidgetContentTypes.CategoryMenu.toString()) {
                  let arrCateMenuIds = this.CommaSpliter(this.widgetContentList[cate1Index].data);
                  for (var i = 0; i < arrCateMenuIds.length; i++) {
                    //populate the left Menu with items
                    var category = this.categoryList.find(s => s.categoryID == parseInt(arrCateMenuIds[i]));
                    if (category != null) {
                      if (category.parentCategoryID == 0) {
                        this.multipleWidgetItems[p].menuParentCategoryList.push(category);
                      } else if (category.isParent == true && category.parentCategoryID > 0) {
                        this.multipleWidgetItems[p].menuCategoryList.push(category);
                      } else if (category.isParent == false) {
                        this.multipleWidgetItems[p].menuSubcategoryList.push(category);
                      }
                    }
                  }
                }

              }
            } else if (widgetTemplate.widgetType == WidgetTypes.PopularCategory.toString()) {
              for (var popularCatIndex = 0; popularCatIndex < this.widgetContentList.length; popularCatIndex++) {
                let arrThumbnailCatIds = this.CommaSpliter(this.widgetContentList[popularCatIndex].data);
                for (var i = 0; i < arrThumbnailCatIds.length; i++) {
                  var selectedPopularCategory = this.categoryList.find(s => s.categoryID == parseInt(arrThumbnailCatIds[i]));
                  this.multipleWidgetItems[p].popularCategoryList.push(selectedPopularCategory);
                }
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.BestVendor.toString()) {
              for (var vendorIndex = 0; vendorIndex < this.widgetContentList.length; vendorIndex++) {
              }
            }  else if (widgetTemplate.widgetType == WidgetTypes.Banner.toString()) {
              for (var bannerIndex = 0; bannerIndex < this.widgetContentList.length; bannerIndex++) {
                let arrUrlAndImage = this.CommaSpliter(this.widgetContentList[bannerIndex].data);
                this.selectedBannerImage[p] = "Images/WidgetContentImages/" + arrUrlAndImage[1];
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.ILoveAppBanner.toString()) {
              for (var bannerIndex = 0; bannerIndex < this.widgetContentList.length; bannerIndex++) {                
                this.selectedILoveAppBannerImage[p] = "Images/WidgetContentImages/" + this.widgetContentList[bannerIndex].data;
              }
            }
          }
        }
      });
  }
  //common functions
  PipeSignSpliter(str: string): string[] {
    return str != "" ? str.toString().split('|') : [];
  }

  ColonSpliter(str: string): string[] {
    return str != "" ? str.toString().split(':') : [];
  }
  CommaSpliter(str: string): string[] {
    return str != "" ? str.toString().split(',') : [];
  }
}
enum WidgetImageContents {
  BrandLeft = "BrandLeft",
  BrandRight = "BrandRight",
  DummyPath = "DummyPath",
  Category = "Category",
}
enum WidgetContentTypes {

  CategoryMenu = "Category Menu",
  HeroImage = "Hero Image",
  ThumbnailCategoryList = "Thumbnail Category List",
  CategoryBannerBrands = "Category Banner Brands",
  BrandTab = "Brand Tab",
  Banner = "Banner",
  BestVendors = "Best Vendors",
  TopSellingProducts = "Top Selling Products",
  RecentProducts = "Recent Products",
  FeaturedProducts = "Featured Products",
  OnsaleProducts = "Onsale Products",
  TopRatedProducts = "Top Rated Products",
  FlashSaleProducts = "Flash Sale Products",
  JustForYou = "Just For You",
}
enum WidgetTypes {

  Category1 = "Category1",
  Category2 = "Category2",
  PopularCategory = "PopularCategory",
  Products = "Products",
  Brands = "Brands",
  BestVendor = "BestVendor",
  Banner = "Banner",
  ILoveAppBanner = "ILoveAppBanner",
}
enum ProductWidgetTypes {
  TopSellingProducts = "Top Selling Products",
  RecentProducts = "Recent Products",
  FeaturedProducts = "Featured Products",
  OnsaleProducts = "Onsale Products",
  TopRatedProducts = "Top Rated Products",
  FlashSaleProducts = "Flash Sale Products",
  JustForYou = "Just For You",
}
export class BrandTabsList {
  public tabTitle: string;
  public BrandsList: Brand[] = [];
}
// For showing multiple widgets
export class MultipleWidgetItems {
  // For Template Id 1 & 2
  public categoryBrandsList: Brand[] = [];
  public thumbnailCategoryList: DisplayCategory[] = [];
  public menuParentCategoryList: DisplayCategory[] = [];
  public menuCategoryList: DisplayCategory[] = [];
  public menuSubcategoryList: DisplayCategory[] = [];
  //For Popular Category widget
  public popularCategoryList: DisplayCategory[] = [];
  // For Brands
  public brandTabsList: BrandTabsList[] = [];

}



// WEBPACK FOOTER //
// ./src/app/widget/page-widget-list/page-widget-list.component.ts